import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Таблица на 100 строк в видимой области. Отсюда решения: липкая шапка,
 * разделители в один пиксель вместо зебры (зебра на такой плотности рябит),
 * подсветка строки под курсором — чтобы глаз не терял её при переводе взгляда
 * от ID к правому краю.
 */
export function Table({ className, ...props }: React.TableHTMLAttributes<HTMLTableElement>) {
  return (
    <table
      className={cn("w-full border-separate border-spacing-0 text-sm", className)}
      {...props}
    />
  )
}

export function TableHeader({ className, ...props }: React.HTMLAttributes<HTMLTableSectionElement>) {
  return <thead className={cn("[&_tr]:border-0", className)} {...props} />
}

export function TableBody({ className, ...props }: React.HTMLAttributes<HTMLTableSectionElement>) {
  return <tbody className={className} {...props} />
}

export function TableRow({ className, ...props }: React.HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr
      className={cn("group transition-colors duration-100 hover:bg-accent-soft/60", className)}
      {...props}
    />
  )
}

export interface TableHeadProps extends React.ThHTMLAttributes<HTMLTableCellElement> {
  align?: "left" | "right" | "center"
}

export function TableHead({ className, align = "left", ...props }: TableHeadProps) {
  return (
    <th
      scope="col"
      className={cn(
        "stencil-label sticky top-0 z-10 whitespace-nowrap border-b border-line-strong bg-surface-sunken px-3 py-2",
        align === "right" && "text-right",
        align === "center" && "text-center",
        align === "left" && "text-left",
        className,
      )}
      {...props}
    />
  )
}

export function TableCell({ className, ...props }: React.TdHTMLAttributes<HTMLTableCellElement>) {
  return (
    <td
      className={cn("border-b border-line px-3 py-2 align-middle text-fg", className)}
      {...props}
    />
  )
}

/**
 * Числовая ячейка: табличные цифры Inter и выравнивание по правому краю.
 * Без переноса — «250.00 EUR», разорванное на две строки, в колонке не читается.
 */
export function TableNumeric({ className, ...props }: React.TdHTMLAttributes<HTMLTableCellElement>) {
  return <TableCell className={cn("whitespace-nowrap text-right tabular-nums", className)} {...props} />
}
